import React, { Component } from 'react';
import Button from "../elements/Buttons";
import HorizontalLine from "../elements/HorizontalLine";

class WelcomeModal extends Component{
    constructor(props){
        super(props);
    }
    
    render(){
        if(this.props.isWelcomeScr && this.props.isWelcomeScr===true){
            return(
                <div className="user-data-modal hasIcon" id="welcomeModel">
                    <div className="pre-chat">
 
                        <form className="text-center only-ar">
                            <div className="user-data-modal-operators">
                                <div className="user-data-modal-operator modal-hasIcon"></div>
                            </div>
                            {this.props.language==='ar' && <div className="user-data-modal-text textAr">
                                <span>حياك الله, معك الخدمة التفاعلية من السعودية للكهرباء</span>
                                
                            </div>}
                            
                            {/* <HorizontalLine className="style1"></HorizontalLine> */}
                            {this.props.language!=='ar' && <div className="user-data-modal-text">
                                <span>Welcome,to the Saudi Electricity Company's Interactive Service.</span>
                            </div>}
                            
                            {this.props.language==='ar' &&
                                <Button
                                    id="langArBtn"
                                    type="button"
                                    classes="user-data-modal-submit inline"
                                    title="دخول"
                                    action={this.props.welcomelangAction}
                                    areaLabel="دخول"
                                    svg="false"
                                >
                            دخول
                                </Button>
                            }

                            {this.props.language!=='ar' && 
                                <Button
                                    id="langEnBtn"
                                    type="button"
                                    classes="user-data-modal-submit inline"
                                    title="Let's start"
                                    action={this.props.welcomelangAction}
                                    areaLabel="Let's start"
                                    svg="false"
                                >
                            Let's start
                                </Button>
                            }
                            
                        </form>
                    
                    </div>
                    {/* <div className="user-data-modal-filler"></div> */}
                </div>
            )
        } else {
            return(null)
        }
        
    }
}
WelcomeModal.propTypes = {
    isWelcomeScr: React.propTypes.node,
    language: React.propTypes.node,
    welcomelangAction: React.propTypes.node,
    minimizeAction: React.propTypes.node,
}
export default WelcomeModal;